export default class CreateWorkerQualificationRequest {
    qualificationId: string;
    status: number;
    source: number;
}